import React, { useEffect, useState } from "react";
import { Card, CardHeader, Collapse, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import icono_interaccion from "../assets/img/icon/interaccion.png";
import axios from "axios";
import { routes } from "../gen/General";

export const CltContacto = ({ clt }) => {
    const [open, setOpen] = useState(false);
    const [dato, setDato] = useState({ modal: false });
    const [item, setItem] = useState({ modalItem: [] });

    const openCollapse = () => {
        setOpen(!open);
    };
    const showDatos = open => {
        setDato({ modal: open });
    };

    const oneSelect = coti => {
        setItem({ modalItem: coti });
    };
    return (
        <div className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Contacto"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <div className={"table-responsive"}>
                        <table className="table table-striped table-hover">
                            <thead className="thead-inverse text-primary">
                                <tr>
                                    <th className="text-left">Item</th>
                                    <th className="text-left">COD</th>
                                    <th className="text-left">C.I.</th>
                                    <th className="text-left st-100">Nombre</th>
                                    <th className="text-left st-100">Apellido</th>
                                    <th className="text-left">Cargo</th>
                                    <th className="text-left">Titulo</th>
                                    <th className="text-left st-100">Fc. Nac</th>
                                    <th className="text-left st-90">Ver Datos</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(clt?.ejecutivos || []).map((a, index) => (
                                    <tr key={a.cdEjecutivo}>
                                        <td className="text-left">
                                            <span>{index + 1}</span>
                                        </td>
                                        <td className="text-left" style={{ minWidth: 80 }}>
                                            <span>{a.cdEjecutivo}</span>
                                        </td>
                                        <td style={{ minWidth: 1 }}>
                                            <span>{a.rucCed}</span>
                                        </td>
                                        <td className="text-left ">
                                            <span>{a.nmEjecutivo}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{a.apEjecutivo}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{a.cargo}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{a.titulo}</span>
                                        </td>
                                        <td className="text-left">
                                            <span>{a.fcNacimiento ? a.fcNacimiento : "-"}</span>
                                        </td>
                                        <td className="st-120 td-actions-primary">
                                            <span
                                                className="mx-4 mx-sm-5 option px-2 text-center"
                                                title="Ver Datos"
                                                onClick={() => {
                                                    oneSelect(a);
                                                    showDatos(true);
                                                }}
                                            >
                                                <img src={icono_interaccion} className={"p-1 st-20 text-center"} />
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Collapse>
                <DatosContactoAdicional open={dato.modal} toggleModal={showDatos} item={item.modalItem} clt={clt} />
            </Card>
        </div>
    );
};
export const DatosContactoAdicional = ({ toggleModal, open, item, clt }) => {
    const [datos, setDatos] = useState({ telefonos: [], emails: [] });

    const closeModal = () => {
        toggleModal(false);
    };

    useEffect(() => {
        if (open && item?.cdEjecutivo) {
            axios
                .get(routes.api + "/usuario/telefonos-emails/" + item.cdEjecutivo)
                .then(resp => {
                    const { telefonos, emails } = resp.data;
                    setDatos({ telefonos, emails });
                })
                .catch(err => console.log("Error obteniendo información de contacto", err));
        }
    }, [open, item.cdEjecutivo]);

    return (
        <Modal className="text-center modal-xl mx-auto" isOpen={open}>
            <ModalHeader className="justify-content-center title" tag="h4">
                Datos del Contacto
                <button type="button" className="close" title="cerrar" onClick={closeModal} aria-label={"Close"}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody className={"pt-2 mb-3"}>
                <div className={"table-responsive"}>
                    <Table className="adjusttd text-center table-striped table-fixed">
                        <thead className="text-primary">
                            <tr>
                                <th>CI</th>
                                <th>Contacto</th>
                                <th>Fc Nacimiento</th>
                                <th>Cargo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <span>{item.rucCed}</span>
                                </td>
                                <td>
                                    <span>
                                        {item.nmEjecutivo + " " + (item.apEjecutivo != null ? item.apEjecutivo : "")}
                                    </span>
                                </td>
                                <td>
                                    <span>{item.fcNacimiento ? item.fcNacimiento : "-"}</span>
                                </td>
                                <td>{item.cargo}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <br />
                <h5 className="card-title">Teléfonos</h5>
                <div className="table-responsive">
                    <Table className="adjusttd text-center table-striped table-fixed">
                        <thead className="text-primary">
                            <tr>
                                <th>Item</th>
                                <th>Tipo</th>
                                <th>Número</th>
                                <th>Extensión</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(datos?.telefonos || []).map((a, index) => (
                                <tr key={index}>
                                    <td>
                                        <span>{index + 1}</span>
                                    </td>
                                    <td>
                                        <span>{a?.TP_TELEFONO || ""}</span>
                                    </td>
                                    <td>
                                        <span>{`${a?.PREFIJO} ${a?.NUM_TELEFONO}`}</span>
                                    </td>
                                    <td>
                                        <span>{a?.EXTENSION || ""}</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                <br />
                <h5 className="card-title">Correos</h5>
                <div className="table-responsive">
                    <Table className="adjusttd text-center table-striped table-fixed">
                        <thead className="text-primary">
                            <tr>
                                <th>Item</th>
                                <th>Correo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(datos?.emails || []).map((a, index) => (
                                <tr key={index}>
                                    <td>
                                        <span>{index + 1}</span>
                                    </td>
                                    <td>
                                        <span>{a || ""}</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </ModalBody>
        </Modal>
    );
};
